import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Info } from "lucide-react";
import Sparkline from "./Sparkline";
import "./cards.css";

/**
 * Premium KPI card. Consistent height, hover lift, sparkline, trend indicator.
 *
 * <MetricCard
 *   label="Monthly Recurring Revenue"
 *   value="$1,722"
 *   trend={+12}             // percentage points or absolute — up to caller
 *   trendLabel="vs last month"
 *   sparkline={[3,5,4,6,8,10,9,12]}
 *   icon={<TrendingUp />}
 *   accent="purple"
 *   tone="info"             // colours the sparkline
 * />
 */
export default function MetricCard({
  label, value, trend = null, trendLabel = "vs last month",
  sparkline = null, icon = null, accent = "purple", tone = "info",
  hint = null, testId,
}) {
  const trendUp   = trend != null && trend > 0;
  const trendDown = trend != null && trend < 0;
  return (
    <motion.div
      className={`hbf-metric hbf-metric--${accent}`}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -2 }}
      data-testid={testId || `metric-${label?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="hbf-metric__header">
        <div className={`hbf-metric__icon hbf-metric__icon--${accent}`}>{icon}</div>
        <div className="hbf-metric__label">{label}</div>
        {hint && (
          <span className="hbf-metric__hint" title={hint}>
            <Info size={12} strokeWidth={2} />
          </span>
        )}
      </div>
      <div className="hbf-metric__value hbf-tabular">{value}</div>
      <div className="hbf-metric__footer">
        {trend != null && (
          <span className={`hbf-metric__trend ${trendUp ? "is-up" : ""} ${trendDown ? "is-down" : ""}`}>
            {trendUp && <TrendingUp size={11} strokeWidth={2.4} />}
            {trendDown && <TrendingDown size={11} strokeWidth={2.4} />}
            {trend > 0 ? "+" : ""}{trend}%
          </span>
        )}
        <span className="hbf-metric__trend-label">{trendLabel}</span>
        <div className="hbf-metric__spark">
          {sparkline && sparkline.length > 1 && (
            <Sparkline points={sparkline} tone={tone} width={104} height={30} />
          )}
        </div>
      </div>
    </motion.div>
  );
}
